module.exports = __webpack_public_path__ + "td/img/cost-total-1.c6745a6c.png";